module.exports = __webpack_public_path__ + "img/mp-rank-item__img-1.bc4b5129.jpg";